exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.report-print-modal[data-v-6a363476] .ant-modal { top: 20px; height: 95%;\n}\n.report-print-modal[data-v-6a363476] .ant-modal-body { height: calc(100% - 55px); overflow: auto;\n}\n.preview-wrapper[data-v-6a363476] { background: #fff; min-height: 400px;\n}\n.print-content[data-v-6a363476] { background: #fff;\n}\n.no-template[data-v-6a363476] { padding: 80px 0; text-align: center;\n}\n.designer-wrapper[data-v-6a363476] { width: 100%; height: calc(100vh - 200px);\n}\n.designer-wrapper.embedded[data-v-6a363476] { height: calc(100vh - 160px);\n}\n", ""]);

// exports
